export const ProgressState = {
  'NotStarted': 'NotStarted',
  'InProgress': 'InProgress',
  'Complete': 'Complete'
}

export const completeProgress = {
    registration: ProgressState.Complete,
    managersAdvisors: ProgressState.NotStarted,
    testing: ProgressState.InProgress,
    questionnaire: ProgressState.InProgress
}

export default completeProgress